<template>
  <div v-if="searchList.filter((s) => s.saved).length" class="dark:text-white text-xl mb-2">
    {{ $t("Saved Searches") }}
  </div>
  <div
    v-if="searchList.filter((s) => s.saved).length"
    class="w-full pl-[10px] pr-[28px] py-[16px] mb-2 rounded-xl shadow-sm flex flex-col dark:bg-dark-box-background bg-light-box-background transition ease-in-out duration-side-menu-transition-duration">
    <div v-for="search_item in searchList.filter((s) => s.saved)" :key="search_item.id">
      <SearchItem :item="search_item" :search-item-click="searchItemClick" :save-or-delete-item-click="saveOrDeleteItemClick" />
    </div>
  </div>

  <div v-if="searchList.filter((s) => !s.saved).length" class="bg-transparent dark:text-white text-xl mb-2">
    {{ $t("Recent Searches") }}
  </div>
  <div
    v-if="searchList.filter((s) => !s.saved).length"
    class="pl-[10px] rounded-xl pr-[28px] py-[16px] shadow-sm dark:bg-dark-box-background bg-light-box-background flex flex-col transition ease-in-out duration-side-menu-transition-duration">
    <div v-for="search_item in searchList.filter((s) => !s.saved)" :key="search_item.id">
      <SearchItem :item="search_item" :search-item-click="searchItemClick" :save-or-delete-item-click="saveOrDeleteItemClick" />
    </div>
  </div>
</template>

<script>
import SearchItem from "./SearchItem.vue"
export default {
  components: {
    SearchItem
  },
  props: {
    searchList: {
      type: Array,
      required: true
    },
    searchItemClick: {
      type: Function,
      required: true
    },
    saveOrDeleteItemClick: {
      type: Function,
      required: true
    }
  },
  emits: ["item-clicked"]
}
</script>
